// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fleet-survey-name-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 28px 0px;
}

.item-center {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.color-red {
  color: red;
}
.select-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 12px;
}

.select-form-control {
  margin-left: 10px;
  margin-right: 18px;
}
.import-dropdown-container {
  display: flex;
  flex-wrap: wrap;
  padding: 1.5rem 0.7rem 0rem 4.5rem;
}

.select-label-container {
  width: 5em;
  text-align: right;
}

.w-14-em {
  width: 14rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/import/styles/ImportDropDowns.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".fleet-survey-name-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 28px 0px;\n}\n\n.item-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.color-red {\n  color: red;\n}\n.select-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin-bottom: 12px;\n}\n\n.select-form-control {\n  margin-left: 10px;\n  margin-right: 18px;\n}\n.import-dropdown-container {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 1.5rem 0.7rem 0rem 4.5rem;\n}\n\n.select-label-container {\n  width: 5em;\n  text-align: right;\n}\n\n.w-14-em {\n  width: 14rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
